import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { MovieCard } from '@/components/MovieCard';
import { Loader2, Film } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState({ movies: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [favoriteMovies, setFavoriteMovies] = useState([]);
  const { user, token } = useAuth();

  useEffect(() => {
    if (query) searchAll();
    if (user) loadFavorites();
  }, [query, user]);

  const searchAll = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/search?q=${encodeURIComponent(query)}`);
      setResults(response.data);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const loadFavorites = async () => {
    if (user && token) {
      try {
        const response = await axios.get(`${API}/favorites`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFavoriteMovies((response.data.movies || []).map(m => m.id));
      } catch (err) {
      }
    }
  };

  const handleFavoriteToggle = () => loadFavorites();

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navigation />
      
      <div className="pt-24 px-4 md:px-8 lg:px-12 xl:px-16 py-8">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bebas font-bold text-white mb-2">
            Résultats pour "{query}"
          </h1>
          <p className="text-text-secondary font-inter">
            {loading ? 'Recherche...' : `${results.total} résultat(s) trouvé(s)`}
          </p>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <Loader2 className="w-12 h-12 text-netflix-red animate-spin" />
          </div>
        ) : (
          <div className="space-y-12">
            {results.movies && results.movies.length > 0 && (
              <div>
                <h2 className="text-2xl md:text-3xl font-work font-bold text-white mb-4 flex items-center gap-3">
                  <Film className="w-7 h-7 text-netflix-red" />
                  Films ({results.movies.length})
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
                  {results.movies.map((movie) => (
                    <MovieCard 
                      key={movie.id} 
                      movie={movie}
                      isFavorite={favoriteMovies.includes(movie.id)}
                      onFavoriteToggle={handleFavoriteToggle}
                    />
                  ))}
                </div>
              </div>
            )}

            {results.total === 0 && !loading && (
              <div className="text-center py-20">
                <p className="text-xl md:text-2xl text-text-secondary font-work">
                  Aucun résultat pour "{query}"
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
